import { FC, useEffect } from 'react';

import { SelectedItemsFromLocalStorage } from '@/components/contextMenu/mwdContextMenu/types';
import MwdDialog from '@/components/UI/Dialog/Dialog';
import { Label } from '@/components/UI/Label/Label';
import Notification from '@/components/UI/Notification/Notification';
import { formatTime } from '@/utils/dateUtils';

import { useMultiVerzwakkenDialog } from './useMultiVerzwakkenDialog';

import styles from '@/components/UI/Dialog/Dialog.module.css';

export type MultiVerzwakkenData = {
  details?: SelectedItemsFromLocalStorage[];
};

type MultiVerzwakkenDataProps = {
  showDialog: boolean;
  handleOpenChange: (p: boolean) => void;
  details: SelectedItemsFromLocalStorage[];
};

const MultiVerzwakkenDialog: FC<MultiVerzwakkenDataProps> = ({ showDialog, handleOpenChange, details }) => {
  const { onSubmit, handleSubmit, resetDialog, clearErrors } = useMultiVerzwakkenDialog(details, handleOpenChange);

  useEffect(() => {
    if (!showDialog) {
      resetDialog(false);
    } else {
      clearErrors();
    }
  }, [showDialog]);

  return (
    <MwdDialog
      title='Verzwakken'
      className={styles.multiMutatieDialogStyle}
      showDialog={showDialog}
      handleOpenChange={handleOpenChange}
      data-testid='contextMenu-multi-verzwakken'
      hasCloseInHeader={true}
    >
      <Notification style={{ height: '48px', marginBottom: '12px' }} iconAlignment='center'>
        Let op: je gaat meerdere inzetten verzwakken
      </Notification>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ marginTop: '12px', marginBottom: '12px' }}>
          <Label>Treinnummers</Label>
          <div
            style={{
              color: 'var(--tractie-color-content-default)',
              marginBottom: '0px',
              display: 'flex',
              columnGap: '40px',
              flexWrap: 'wrap',
            }}
          >
            {details.map((d) => (
              <div key={d.treinnummer}>{d.treinnummer}</div>
            ))}
          </div>
        </div>
        <div style={{ marginTop: '12px', marginBottom: '12px' }}>
          <Label>Stelnummer</Label>
          <div
            style={{
              color: 'var(--tractie-color-content-default)',
              marginBottom: '0px',
              display: 'flex',
              columnGap: '40px',
              flexWrap: 'wrap',
            }}
          >
            {details[0].stelNummer}
          </div>
        </div>
        <div
          style={{
            height: '2px',
            marginBottom: '14px',
            marginTop: '14px',
            width: '100%',
            background: 'var(--tractie-color-border-subtle)',
          }}
        />
        <div style={{ display: 'flex', flexDirection: 'row', columnGap: '130px' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Label>Van (eerste inzet)</Label>
            <div style={{ color: 'var(--tractie-color-content-default)', marginBottom: '12px' }}>
              {`${details[0].dienstregelpuntVan} - ${formatTime(new Date(details[0].vertrekTijd))}`}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Label>Tot (laatste inzet)</Label>
            <div style={{ color: 'var(--tractie-color-content-default)', marginBottom: '12px' }}>
              {`${details[details.length - 1].dienstregelpuntNaar} -  ${formatTime(new Date(details[details.length - 1].aankomstTijd))}`}
            </div>
          </div>
        </div>
        <MwdDialog.Footer
          confirmButtonType='destructive'
          submitCaption={`Verzwak ${details.length} inzetten`}
          cancelCallback={() => resetDialog(true)}
        />
      </form>
    </MwdDialog>
  );
};

export default MultiVerzwakkenDialog;
